export default "__VITE_ASSET__CG0wGchJ__"